import store from '@/store';
import { p2pActions } from '@/store/p2p-slice';

import { sendP2PSocketData } from './p2pConnection';

export const loginSuccessHandler = (dataRec: boolean) => {
    store.dispatch(p2pActions.updatePeerFound('Searching for peers'));

    const activeServer = store.getState().serverDataReducer.activeServer;

    const serverDetails =
        store.getState().serverDataReducer.serverData?.[activeServer];
    const privateKey = serverDetails?.privateKey ?? '';

    if (store.getState().p2pReducer.availableCondition) {
        sendP2PSocketData({
            command: 'setavailable',
            data: [],
        });
    } else {
        store.dispatch(p2pActions.setAvailableCondition(true));
    }

    if (!dataRec || !privateKey || privateKey === '') {
        sendP2PSocketData({
            command: 'getpeer',
            data: [],
        });
    } else {
    }
};
